import { Col, Input, Row } from 'antd';
import React, { Component } from 'react';
import { shipmentStatus } from './../../../../../constants';
import Items from './../items';
import './RowPackage.css';

class RowPackage extends Component {
    renderItem = () => {
        return (
            <tr id="row-package">
                <td />
                <td colSpan={10} id="item-information">
                    <Items
                        shipment={this.props.shipment}
                        package={this.props.package}
                        items={this.props.package.Items}
                    />
                </td>
            </tr>
        )
    }
    renderStatusShipment = (statusID) => {
        switch (statusID) {
            case shipmentStatus.AWAITING_PACKAGE_INFO:
                return 'Awaiting Package Info'
            case shipmentStatus.READY_TO_PRINT:
                return 'Ready To Print'
            case shipmentStatus.READY_TO_TRANSMIT:
                return 'Ready To Transmit '
            case shipmentStatus.TRANSMITED:
            case shipmentStatus.TRANSMITED_KTE:
            case shipmentStatus.IMPORTED_KTE:
                return 'Shipped'
            case shipmentStatus.SHIPPED:
            case shipmentStatus.ARRIVED_AT_DESTINATION:
            case shipmentStatus.OUT_FOR_DELIVERY:
                return 'In Transit'
            case shipmentStatus.DELIVERY_DELIVERED:
                return 'Delivered'
            case shipmentStatus.PENDING_TRANSMIT:
                return 'Pending Transmit'
            case shipmentStatus.FULFILLMENT_IN_PROCESS: 
                return 'Fulfillment In Process'
            case shipmentStatus.SHIPPING_IN_PROCESS: 
                return 'Shipping In Process'
            case shipmentStatus.FULFILLMENT_COMPLETED: 
                return 'Fulfillment Completed'
            case shipmentStatus.PENDING_SHIPPING_IN_PROCESS: 
                return 'Pending Shipping In Process'
            default:
                return ''
        }
    }
    render() {
        const packageData = this.props.package

        return (
            <tr id="row-package">
                <td><span className='no'>{this.props.no}</span></td>
                <td>
                    <Input
                        name='package id'
                        value={packageData.PackageNumberCH}
                        disabled
                    />
                </td>
                <td>
                    <Input
                        name='tracking no'
                        value={packageData.TrackingNumberCH}
                        disabled
                    />
                </td>
                <td>
                    <Input
                        value={packageData.GrossWeightFL}
                        name='package gwt'
                        disabled
                    />
                </td>
                <td>
                    <Input
                        name='status package'
                        value={this.renderStatusShipment(packageData.StatusID)}
                        disabled
                    />
                </td>
                <td className="lwh">
                    <Row gutter={16}>
                        <Col span={8}><Input name='lwh_l' value={'L:' + packageData.LengthFL ? packageData.LengthFL : ''} disabled /></Col>
                        <Col span={8}><Input name='lwh_w' value={'W:' + packageData.WidthFL ? packageData.WidthFL : ''} disabled /></Col>
                        <Col span={8}><Input name='lwh_h' value={'H:' + packageData.HeightFL ? packageData.HeightFL : ''} disabled /></Col>
                    </Row>
                </td>
            </tr>
        )
    }
}

export default RowPackage



// WEBPACK FOOTER //
// ./src/containers/shipments/detail-shipment/components/packages/RowPackage.js